// Unit system helper functions

/**
 * Get the unit symbol for a given unit system
 * @param {string} unitSystem - The unit system ('imperial', 'metric', 'meters', 'millimeters')
 * @returns {string} - The unit symbol
 */
export const getUnitSymbol = (unitSystem) => {
  switch (unitSystem) {
    case 'imperial':
      return '"';
    case 'metric':
      return 'cm';
    case 'meters':
      return 'm';
    case 'millimeters':
      return 'mm';
    default:
      return '"'; // Default to inches
  }
};

/**
 * Get the full unit label for dropdown display
 * @param {string} unitSystem - The unit system ('imperial', 'metric', 'meters', 'millimeters')
 * @returns {string} - The full unit label
 */
export const getUnitLabel = (unitSystem) => {
  switch (unitSystem) {
    case 'imperial':
      return 'Inches (")';
    case 'metric':
      return 'Centimeters (cm)';
    case 'meters':
      return 'Meters (m)';
    case 'millimeters':
      return 'Millimeters (mm)';
    default:
      return 'Inches (")';
  }
};

